export enum FREState {
    Welcome = 0, // the first modal that is shown to the user
    ClickedModal = 1,
}
